import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import PlanTypePage from './PlanTypePage';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchGuidedPathPlanType } from './companyGuidedPathApi';
import { PLAN_LABELS } from './guidedPathTheme';

/**
 * Route wrapper for one kind of plan. Both kinds render the same page, so two
 * near-identical wrappers would have said nothing the route tree doesn't.
 *
 * THE KIND IS FIXED BY THE ROUTE, NOT READ OUT OF THE URL. It is passed in by
 * whichever route rendered this component, so a hand-typed segment cannot
 * select a third thing. The backend rejects an unknown kind anyway; this stops
 * the page from asking in the first place.
 */
const CPlanTypePage = ({ planType }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchGuidedPathPlanType(planType, department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [planType, isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{PLAN_LABELS[planType] || 'Guided Path'} | Shoorah</title>
      </Helmet>
      <PlanTypePage fetcher={fetcher} populationLabel={isB2BFansMode ? 'members' : 'employees'} />
    </div>
  );
};

CPlanTypePage.propTypes = {
  planType: PropTypes.oneOf(['ai', 'custom']).isRequired
};

export const CGuidedPathAiPlan = () => <CPlanTypePage planType="ai" />;
export const CGuidedPathCustomPlan = () => <CPlanTypePage planType="custom" />;

export default CPlanTypePage;
